/**
 * Gully Labs — gift wrap helper
 * - Cart: per-unit gift wrap under each visually split cart row
 * - Qty > 1 products render as separate unit rows (see cart-drawer)
 */
(function () {
  if (window.__glAutoGiftWrapInit) return;
  window.__glAutoGiftWrapInit = true;

  window.GLGiftWrapSkipAttr = 'gl_skip_gift_wrap';
  window.GLGiftWrapSync = function () {
    return Promise.resolve();
  };

  var PROP_PRODUCT = '_rakhi_for_product';
  var PROP_VARIANT = '_rakhi_for_variant';
  var PROP_KEY = '_rakhi_for_key';
  var PROP_UNIT = '_rakhi_unit';

  // Visible on Shopify admin orders (names must NOT start with _)
  var PROP_FOR_PRODUCT = 'For product';
  var PROP_FOR_SKU = 'Product SKU';
  var PROP_FOR_VARIANT = 'Variant';
  var PROP_GIFT_TYPE = 'Gift type';

  function buildSellerProps(source) {
    var props = {};
    var title = '';
    var sku = '';
    var vtitle = '';

    if (source && source.getAttribute) {
      title = source.getAttribute('data-product-title') || '';
      sku = source.getAttribute('data-product-sku') || '';
      vtitle = source.getAttribute('data-variant-title') || '';
    } else if (source) {
      title = source.product_title || source.title || '';
      sku = source.sku || '';
      vtitle = source.variant_title || '';
      // Cart JS titles often include variant: "Name - Variant"
      if (!title && source.title) title = source.title;
    }

    if (title) props[PROP_FOR_PRODUCT] = String(title);
    if (sku) props[PROP_FOR_SKU] = String(sku);
    if (vtitle && vtitle !== 'Default Title') props[PROP_FOR_VARIANT] = String(vtitle);
    props[PROP_GIFT_TYPE] = 'Rakhi gift wrap';
    return props;
  }

  function copyVisibleProps(fromProps, into) {
    var out = into || {};
    if (!fromProps) return out;
    Object.keys(fromProps).forEach(function (key) {
      if (key && key.charAt(0) !== '_') out[key] = fromProps[key];
    });
    return out;
  }

  function ajaxUrl(path) {
    var routes = (window.theme && theme.routes) || {};
    var map = {
      cart: routes.cart_url || '/cart',
      add: routes.cart_add_url || '/cart/add',
      change: routes.cart_change_url || '/cart/change',
      update: routes.cart_update_url || '/cart/update'
    };
    var url = map[path] || '/cart';
    if (url.indexOf('.js') === -1) url += '.js';
    return url;
  }

  function fetchConfig() {
    return {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  }

  function bundleSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function getCart() {
    return fetch(ajaxUrl('cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) {
      return r.json();
    });
  }

  function mergeCartPayload(partial, full) {
    if (!full) return partial;
    if (!partial) return full;
    var merged = Object.assign({}, full);
    if (partial.sections) merged.sections = partial.sections;
    return merged;
  }

  function normalizeCart(cart) {
    if (isFullCart(cart)) return Promise.resolve(cart);
    return getCart()
      .then(function (full) {
        return mergeCartPayload(cart, full);
      })
      .catch(function () {
        return cart;
      });
  }

  function themeCartPayload(cart) {
    var payload = Object.assign({}, cart || {});
    var facing = customerFacingItemCount(cart);
    if (facing !== null && facing !== undefined && !isNaN(facing)) {
      payload.item_count = facing;
    }
    return payload;
  }

  function publishCart(cart) {
    normalizeCart(cart)
      .then(function (normalized) {
        if (!normalized) return;

        updateCartCountBadges(normalized);
        if (window.GLGiftWrapEligibility && typeof GLGiftWrapEligibility.hideIneligibleCartButtons === 'function') {
          GLGiftWrapEligibility.hideIneligibleCartButtons();
        }
        if (typeof window.tlSyncCartCustomNameNotes === 'function') {
          window.tlSyncCartCustomNameNotes(normalized);
        }
        if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'gl-cart-gift-wrap',
            cart: themeCartPayload(normalized)
          });
        }
        document.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })
        );
      })
      .catch(function () {});
  }

  window.GLGiftWrapPublishCart = publishCart;

  function isWrapItem(item, wrapId) {
    if (item.handle === 'gift-wrap-it') return true;
    if (window.GL_GIFT_WRAP && String(item.variant_id) === String(window.GL_GIFT_WRAP.variantId)) {
      return true;
    }
    if (wrapId && (String(item.variant_id) === String(wrapId) || String(item.id) === String(wrapId))) {
      return true;
    }
    return false;
  }

  function isLinkedWrapLine(item) {
    if (!isWrapItem(item)) return false;
    var props = item.properties || {};
    if (props[PROP_KEY] || props[PROP_PRODUCT]) return true;
    if (props[PROP_FOR_PRODUCT] || props['For product']) return true;
    return false;
  }

  function productLinesByKey(cart) {
    var map = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (!isWrapItem(item)) map[item.key] = item;
    });
    return map;
  }

  function wrapClaimKey(item) {
    var props = item.properties || {};
    return props[PROP_KEY] || props._rakhi_for_key || '';
  }

  function wrapUnit(item) {
    var props = item.properties || {};
    var u = props[PROP_UNIT];
    if (u === undefined || u === null || u === '') return '0';
    return String(u);
  }

  /** Wrap lines that should not be in cart (ghost legacy rows, stale keys, dupes). */
  function isStaleWrap(item, productKeys) {
    if (!isWrapItem(item)) return false;
    var props = item.properties || {};

    if (!isLinkedWrapLine(item)) return true;

    var forKey = wrapClaimKey(item);
    if (forKey) {
      if (!productKeys[forKey]) return true;
      var parent = productKeys[forKey];
      if (window.GLGiftWrapEligibility && GLGiftWrapEligibility.isIneligibleProduct(parent)) {
        return true;
      }
      var unit = parseInt(wrapUnit(item), 10);
      if (isNaN(unit)) unit = 0;
      var maxUnit = Math.max(0, (parent.quantity || 1) - 1);
      if (unit > maxUnit) return true;
      return false;
    }

    var forProduct = props[PROP_PRODUCT];
    if (forProduct) {
      for (var k in productKeys) {
        if (String(productKeys[k].product_id) === String(forProduct)) {
          if (window.GLGiftWrapEligibility && GLGiftWrapEligibility.isIneligibleProduct(productKeys[k])) {
            return true;
          }
          return false;
        }
      }
      return true;
    }

    // Visible-only props with no internal link (legacy bulk gift-wrapping add)
    return true;
  }

  function wrapDedupeId(item) {
    var key = wrapClaimKey(item);
    if (key) return key + '|' + wrapUnit(item);
    var props = item.properties || {};
    return 'p:' + String(props[PROP_PRODUCT] || '') + '|' + wrapUnit(item);
  }

  function customerFacingItemCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    var total = 0;
    cart.items.forEach(function (item) {
      if (isWrapItem(item)) return;
      total += item.quantity || 1;
    });
    return total;
  }

  function isFullCart(cart) {
    return !!(cart && Array.isArray(cart.items) && typeof cart.item_count === 'number');
  }

  /** /cart/add.js often returns only the added line(s) — not safe for badge updates. */
  function updateCartCountBadges(cart) {
    if (!isFullCart(cart)) {
      return getCart()
        .then(function (full) {
          updateCartCountBadges(full);
        })
        .catch(function () {});
    }

    var count = customerFacingItemCount(cart);
    if (count === null || count === undefined || isNaN(count)) return;

    document.querySelectorAll('cart-count').forEach(function (el) {
      el.textContent = String(count);
      el.hidden = count === 0;
    });
  }

  /** Remove ghost / stale / duplicate Rakhi Gift lines left by legacy gift-wrapping. */
  function removeOrphanGiftWraps(cart) {
    var items = (cart && cart.items) || [];
    var productKeys = productLinesByKey(cart);
    var updates = {};
    var seen = {};
    var found = false;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!isWrapItem(item)) continue;

      if (isStaleWrap(item, productKeys)) {
        updates[item.key] = 0;
        found = true;
        continue;
      }

      var dedupe = wrapDedupeId(item);
      if (seen[dedupe]) {
        updates[item.key] = 0;
        found = true;
      } else {
        seen[dedupe] = true;
      }
    }

    if (!found) {
      updateCartCountBadges(cart);
      return Promise.resolve(cart);
    }

    var body = JSON.stringify({
      updates: updates,
      sections: bundleSections(),
      sections_url: window.location.pathname
    });

    return fetch(ajaxUrl('update'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    }).then(function (res) {
      if (res && res.status && res.status !== 200) {
        throw new Error(res.description || res.message || 'Gift wrap cleanup failed');
      }
      if (res && res.sections) {
        publishCart(res);
        return res;
      }
      return getCart().then(function (fresh) {
        publishCart(fresh);
        return fresh;
      });
    });
  }

  var sanitizePending = false;
  function scheduleSanitize(cart) {
    if (sanitizePending) return Promise.resolve(cart);
    sanitizePending = true;
    return remapStaleWrapKeys(cart || {})
      .then(function (next) {
        return removeOrphanGiftWraps(next || cart || {});
      })
      .finally(function () {
        sanitizePending = false;
      });
  }

  function findWrapLine(cart, btn) {
    var wrapId = btn.getAttribute('data-wrap-variant-id');
    var productId = btn.getAttribute('data-product-id');
    var lineKey = btn.getAttribute('data-line-key');
    var unitIndex = String(btn.getAttribute('data-unit-index') || '0');
    var items = (cart && cart.items) || [];

    function unitMatches(forUnit) {
      if (forUnit != null && String(forUnit) !== '' && String(forUnit) === unitIndex) return true;
      if ((forUnit == null || forUnit === '') && unitIndex === '0') return true;
      return false;
    }

    function firstProductLineKey() {
      for (var i = 0; i < items.length; i++) {
        var row = items[i];
        if (isWrapItem(row, wrapId)) continue;
        if (row.handle === 'gift-wrap-it') continue;
        if (String(row.product_id) === String(productId)) return row.key;
      }
      return null;
    }

    for (var j = 0; j < items.length; j++) {
      var item = items[j];
      if (!isWrapItem(item, wrapId)) continue;
      var props = item.properties || {};
      var forKey = props[PROP_KEY];
      var forProduct = props[PROP_PRODUCT];
      var forUnit = props[PROP_UNIT];

      // Exact line key wins — never share wrap across two shoes of the same product
      if (forKey) {
        if (String(forKey) === String(lineKey) && unitMatches(forUnit)) return item;
        var forVariant = props[PROP_VARIANT];
        if (
          forProduct &&
          String(forProduct) === String(productId) &&
          unitMatches(forUnit) &&
          (!forVariant || String(forVariant) === String(btn.getAttribute('data-product-variant-id')))
        ) {
          return item;
        }
        continue;
      }

      // Legacy (product only): bind to the first line of that product
      if (forProduct && String(forProduct) === String(productId) && unitMatches(forUnit)) {
        if (String(firstProductLineKey()) === String(lineKey)) return item;
      }
    }
    return null;
  }

  function setButtonState(btn, added, wrapKey) {
    btn.classList.toggle('is-added', !!added);
    btn.setAttribute('aria-pressed', added ? 'true' : 'false');
    btn.setAttribute('aria-label', added ? 'Remove gift wrap' : 'Make it a rakhi gift');
    if (wrapKey) btn.setAttribute('data-wrap-line-key', wrapKey);
    else btn.setAttribute('data-wrap-line-key', '');
  }

  function enableLoader(btn) {
    var row = btn.closest('[data-gl-unit-row], li, tr');
    if (!row) return;
    var key = btn.getAttribute('data-line-key');
    var unit = btn.getAttribute('data-unit-index') || '0';
    var loader =
      document.getElementById('Loader-' + key + '-' + unit) ||
      document.getElementById('Loader-' + key) ||
      (row && row.querySelector('[id^="Loader-"]'));
    if (loader) loader.hidden = false;
    var cartItems = btn.closest('cart-items');
    if (cartItems && typeof cartItems.enableLoading === 'function') {
      cartItems.enableLoading(key);
    }
  }

  function disableLoader(btn) {
    if (!btn) return;
    var key = btn.getAttribute('data-line-key');
    var unit = btn.getAttribute('data-unit-index') || '0';
    var loader =
      document.getElementById('Loader-' + key + '-' + unit) ||
      document.getElementById('Loader-' + key);
    if (loader) loader.hidden = true;
    var cartItems = btn.closest('cart-items');
    if (cartItems && typeof cartItems.disableLoading === 'function' && key) {
      cartItems.disableLoading(key);
    }
  }

  function findGiftWrapButton(lineKey, unitIndex) {
    if (!lineKey) return null;
    var unit = unitIndex || '0';
    var selector =
      '[data-gl-cart-gw][data-line-key="' +
      String(lineKey).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
      '"][data-unit-index="' +
      unit +
      '"]';
    return document.querySelector(selector);
  }

  function cartPayload(res) {
    return res && res.items ? res : null;
  }

  /** Render cart drawer / main-cart sections without mutating line items. */
  function fetchCartWithSections() {
    var sections = bundleSections();
    if (!sections.length) return getCart();

    var body = JSON.stringify({
      sections: sections,
      sections_url: window.location.pathname
    });

    return fetch(ajaxUrl('update'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    });
  }

  window.GLGiftWrapRefreshSections = function (res) {
    if (res && res.sections) return Promise.resolve(res);
    return fetchCartWithSections();
  };

  function finishGiftWrapUpdate(res, lineKey, unitIndex) {
    return window.GLGiftWrapRefreshSections(res).then(function (cart) {
      publishCart(cart);
      return cart;
    });
  }

  function findParentForWrap(wrap, productKeys, items) {
    var props = wrap.properties || {};
    var forKey = wrapClaimKey(wrap);
    if (forKey && productKeys[forKey]) return productKeys[forKey];

    var forProduct = props[PROP_PRODUCT];
    var forVariant = props[PROP_VARIANT];
    var candidates = [];

    Object.keys(productKeys).forEach(function (key) {
      var parent = productKeys[key];
      if (forProduct && String(parent.product_id) !== String(forProduct)) return;
      if (forVariant && String(parent.variant_id) !== String(forVariant)) return;
      candidates.push(parent);
    });

    if (!candidates.length && forProduct) {
      (items || []).forEach(function (row) {
        if (isWrapItem(row)) return;
        if (String(row.product_id) === String(forProduct)) candidates.push(row);
      });
    }

    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];

    var unit = parseInt(wrapUnit(wrap), 10);
    if (isNaN(unit)) unit = 0;
    if (unit < candidates.length) return candidates[unit];
    return candidates[0];
  }

  function mergeWrapProps(oldProps, parent) {
    var props = copyVisibleProps(oldProps, {});
    props[PROP_PRODUCT] = String((oldProps && oldProps[PROP_PRODUCT]) || parent.product_id);
    props[PROP_VARIANT] = String((oldProps && oldProps[PROP_VARIANT]) || parent.variant_id);
    props[PROP_KEY] = String(parent.key);
    props[PROP_UNIT] = wrapUnit({ properties: oldProps || {} });
    if (!props[PROP_GIFT_TYPE]) props[PROP_GIFT_TYPE] = 'Rakhi gift wrap';
    return props;
  }

  /** Discount / cart updates can rotate line keys — re-link wraps instead of deleting them. */
  function remapStaleWrapKeys(cart) {
    var items = (cart && cart.items) || [];
    var productKeys = productLinesByKey(cart);
    var chain = Promise.resolve(null);
    var remapped = false;

    items.forEach(function (item) {
      if (!isWrapItem(item) || !isLinkedWrapLine(item)) return;

      var forKey = wrapClaimKey(item);
      if (forKey && productKeys[forKey]) return;

      var parent = findParentForWrap(item, productKeys, items);
      if (!parent) return;
      if (forKey && String(forKey) === String(parent.key)) return;

      remapped = true;
      chain = chain.then(function () {
        var body = JSON.stringify({
          id: item.key,
          quantity: item.quantity || 1,
          properties: mergeWrapProps(item.properties, parent),
          sections: bundleSections(),
          sections_url: window.location.pathname
        });
        return fetch(ajaxUrl('change'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
          return r.json();
        });
      });
    });

    if (!remapped) return Promise.resolve(cart);

    return chain.then(function (res) {
      if (res && res.sections) return res;
      if (res && res.items) return res;
      return getCart();
    });
  }

  function clearCartPointerBlock() {
    document.querySelectorAll('cart-items').forEach(function (el) {
      el.classList.remove('pointer-events-none');
    });
  }

  function addWrap(btn) {
    if (window.GLGiftWrapEligibility && !GLGiftWrapEligibility.isProductEligible(btn)) {
      return Promise.reject(new Error('Gift wrap is not available for this product'));
    }

    var props = buildSellerProps(btn);
    props[PROP_PRODUCT] = String(btn.getAttribute('data-product-id') || '');
    props[PROP_VARIANT] = String(btn.getAttribute('data-product-variant-id') || '');
    props[PROP_KEY] = String(btn.getAttribute('data-line-key') || '');
    props[PROP_UNIT] = String(btn.getAttribute('data-unit-index') || '0');

    var body = JSON.stringify({
      items: [
        {
          id: Number(btn.getAttribute('data-wrap-variant-id')),
          quantity: 1,
          properties: props
        }
      ],
      sections: bundleSections(),
      sections_url: window.location.pathname
    });

    return fetch(ajaxUrl('add'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    });
  }

  function removeWrap(btn, wrapItem) {
    var key = (wrapItem && wrapItem.key) || btn.getAttribute('data-wrap-line-key');
    if (!key) return Promise.resolve(null);

    var body = JSON.stringify({
      id: key,
      quantity: 0,
      sections: bundleSections(),
      sections_url: window.location.pathname
    });

    return fetch(ajaxUrl('change'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    });
  }

  function changeLineQty(lineKey, quantity) {
    var body = JSON.stringify({
      id: lineKey,
      quantity: Math.max(0, quantity),
      sections: bundleSections(),
      sections_url: window.location.pathname
    });
    return fetch(ajaxUrl('change'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    });
  }

  /** Add a brand-new cart line (unique property) so each unit can wrap independently */
  function addDistinctUnit(row) {
    var variantId = row.getAttribute('data-variant-id');
    if (!variantId) return Promise.reject(new Error('Missing variant id'));

    var props = {
      _gl_uid: 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7)
    };

    var body = JSON.stringify({
      items: [
        {
          id: Number(variantId),
          quantity: 1,
          properties: props
        }
      ],
      sections: bundleSections(),
      sections_url: window.location.pathname
    });

    return fetch(ajaxUrl('add'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
      return r.json();
    });
  }

  function wrapsForParent(cart, wrapId, productId, lineKey) {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (!isWrapItem(item, wrapId)) continue;
      var props = item.properties || {};
      var forKey = props[PROP_KEY];
      // Only wraps tied to this exact cart line
      if (forKey && String(forKey) === String(lineKey)) {
        out.push(item);
      }
    }
    return out;
  }

  /**
   * After removing unitIndex from a line, drop that unit's wrap and
   * shift higher unit wraps down by one so indices stay contiguous.
   */
  function remapWrapsAfterUnitRemove(cart, row) {
    var wrapId = row.getAttribute('data-wrap-variant-id');
    var productId = row.getAttribute('data-product-id');
    var lineKey = row.getAttribute('data-line-key');
    var removedUnit = parseInt(row.getAttribute('data-unit-index') || '0', 10);
    var wraps = wrapsForParent(cart, wrapId, productId, lineKey);

    var chain = Promise.resolve();
    wraps.forEach(function (wrap) {
      var props = wrap.properties || {};
      var unit = props[PROP_UNIT];
      var unitNum = unit === undefined || unit === null || unit === '' ? 0 : parseInt(unit, 10);
      if (isNaN(unitNum)) unitNum = 0;

      if (unitNum === removedUnit) {
        chain = chain.then(function () {
          return changeLineQty(wrap.key, 0);
        });
      } else if (unitNum > removedUnit) {
        chain = chain
          .then(function () {
            return changeLineQty(wrap.key, 0);
          })
          .then(function () {
            var newProps = copyVisibleProps(props, {});
            newProps[PROP_PRODUCT] = String(productId || props[PROP_PRODUCT] || '');
            newProps[PROP_VARIANT] = String(props[PROP_VARIANT] || '');
            newProps[PROP_KEY] = String(lineKey || props[PROP_KEY] || '');
            newProps[PROP_UNIT] = String(unitNum - 1);
            if (!newProps[PROP_GIFT_TYPE]) newProps[PROP_GIFT_TYPE] = 'Rakhi gift wrap';
            var body = JSON.stringify({
              items: [{ id: Number(wrapId || wrap.variant_id), quantity: 1, properties: newProps }],
              sections: bundleSections(),
              sections_url: window.location.pathname
            });
            return fetch(ajaxUrl('add'), Object.assign(fetchConfig(), { body: body })).then(function (r) {
              return r.json();
            });
          });
      }
    });
    return chain;
  }

  function onToggleClick(event) {
    var btn = event.target.closest('[data-gl-cart-gw]');
    if (!btn || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    var lineKey = btn.getAttribute('data-line-key');
    var unitIndex = btn.getAttribute('data-unit-index') || '0';
    var added = btn.classList.contains('is-added') || btn.getAttribute('aria-pressed') === 'true';

    if (!added && window.GLGiftWrapEligibility && !GLGiftWrapEligibility.isProductEligible(btn)) {
      return;
    }

    clearCartPointerBlock();
    btn.disabled = true;
    enableLoader(btn);

    var action = added
      ? getCart().then(function (cart) {
          return removeWrap(btn, findWrapLine(cart, btn));
        })
      : addWrap(btn);

    action
      .then(function (res) {
        if (res && res.status && res.status !== 200) {
          throw new Error(res.description || res.message || 'Gift wrap update failed');
        }
        return finishGiftWrapUpdate(res, lineKey, unitIndex);
      })
      .then(function (cart) {
        if (cart && cart.sections) return;
        var freshBtn = findGiftWrapButton(lineKey, unitIndex) || btn;
        var data = cartPayload(cart) || cart;
        var wrap = findWrapLine(data, freshBtn);
        setButtonState(freshBtn, !!wrap, wrap && wrap.key);
        if (isFullCart(data)) updateCartCountBadges(data);
      })
      .catch(function (err) {
        console.warn('[gl-cart-gift-wrap]', err);
        getCart()
          .then(function (cart) {
            var freshBtn = findGiftWrapButton(lineKey, unitIndex) || btn;
            var wrap = findWrapLine(cart, freshBtn);
            setButtonState(freshBtn, !!wrap, wrap && wrap.key);
            publishCart(cart);
          })
          .catch(function () {});
      })
      .finally(function () {
        var freshBtn = findGiftWrapButton(lineKey, unitIndex) || btn;
        disableLoader(freshBtn);
        clearCartPointerBlock();
        if (freshBtn) freshBtn.disabled = false;
      });
  }

  function onUnitQtyClick(event) {
    var plus = event.target.closest('[data-gl-unit-row] [name="plus"]');
    var minus = event.target.closest('[data-gl-unit-row] [name="minus"]');
    var remove = event.target.closest('[data-gl-unit-remove]');
    if (!plus && !minus && !remove) return;

    var row = (plus || minus || remove).closest('[data-gl-unit-row]');
    if (!row) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var lineKey = row.getAttribute('data-line-key');
    var lineQty = parseInt(row.getAttribute('data-line-qty') || '1', 10);
    if (!lineKey || isNaN(lineQty)) return;

    row.setAttribute('aria-busy', 'true');

    var action;
    if (plus) {
      // Always create a separate cart line (not qty++) so gift wrap stays per-unit
      action = addDistinctUnit(row);
    } else {
      var nextQty = lineQty - 1;
      action = getCart()
        .then(function (cart) {
          return remapWrapsAfterUnitRemove(cart, row);
        })
        .then(function () {
          return changeLineQty(lineKey, nextQty);
        });
    }

    action
      .then(function (res) {
        if (res && res.status && res.status !== 200) {
          throw new Error(res.description || res.message || 'Quantity update failed');
        }
        // Prefer response with sections; otherwise fetch cart and force section refresh
        if (res && res.sections) {
          publishCart(res);
          return;
        }
        return getCart().then(publishCart);
      })
      .catch(function (err) {
        console.warn('[gl-cart-unit]', err);
        getCart().then(publishCart).catch(function () {});
      })
      .finally(function () {
        row.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', onToggleClick);
  document.addEventListener('click', onUnitQtyClick, true);

  if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cart) return;
      // Keep header count as product units only (gift wrap is a hidden add-on line).
      setTimeout(function () {
        if (isFullCart(event.cart)) {
          updateCartCountBadges(event.cart);
        }
      }, 0);
    });

    theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cart) return;
      if (event.source === 'gl-cart-gift-wrap' || event.source === 'rakhi-gift-wrap') return;
      scheduleSanitize(event.cart).catch(function (err) {
        console.warn('[gl-cart-gift-wrap] orphan cleanup', err);
      });
    });
  }

  function bootSanitize() {
    getCart()
      .then(scheduleSanitize)
      .catch(function () {});
    if (window.GLGiftWrapEligibility && typeof GLGiftWrapEligibility.hideIneligibleCartButtons === 'function') {
      GLGiftWrapEligibility.hideIneligibleCartButtons();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootSanitize);
  } else {
    bootSanitize();
  }
})();
